export const makeImgUrl = (fileName: string) => `/assets/img/upload-location-type-icons/${fileName}`;
